import {
  FileTypeValidatorConfiguration,
  ValidationResult,
  ValidatorResult,
} from '../index';
import _last from 'lodash.last';
import {
  AnnotationShape,
  LogoShape,
} from '@/web-components/import-wizard/typings/pintura';

export const fileTypeValidator =
  (validatorConfiguration: string, shape: LogoShape, printPositionId: string) =>
  ({ payload, validationResult }: ValidatorResult): ValidatorResult => {
    const validatorName = 'fileTypeValidator';
    const vectorFileValidatorName = 'vectorFileValidator';

    let {
      validFileExtensions,
      // eslint-disable-next-line prefer-const
      isTrueVectorFile,
    }: FileTypeValidatorConfiguration = JSON.parse(validatorConfiguration);

    if (validFileExtensions.length > 0) {
      validFileExtensions = validFileExtensions
        .map((name) => name.toLowerCase())
        .filter((ext) => ext !== '.svg' && ext !== 'svg');
    }

    const { fileName, isVectorFileTrueVectorFile } = shape;
    const partsOfFileName: string[] = fileName?.split('.') as string[];
    let fileExtension = '.' + _last(partsOfFileName);

    if (fileExtension !== undefined) {
      fileExtension = fileExtension.toLowerCase();
    }

    const isValidFileExtension: boolean =
      fileExtension === undefined
        ? false
        : validFileExtensions.includes(fileExtension);

    payload.id = shape.id;
    payload.personalizationArtworkId = shape.personalizationArtworkId as string;
    payload.fileName = shape.fileName as string;

    if (
      fileExtension === '.ai' ||
      fileExtension === '.pdf' ||
      fileExtension === '.eps'
    ) {
      const isTrueVectorFileResult = isTrueVectorFile
        ? isVectorFileTrueVectorFile
        : true;
      return {
        payload,
        validationResult: validationResult.concat([
          {
            printPositionId: printPositionId,
            validatorName:
              isValidFileExtension && !isVectorFileTrueVectorFile
                ? vectorFileValidatorName
                : validatorName,
            validatorColor:
              isValidFileExtension && isTrueVectorFileResult ? 'Green' : 'Red',
            message: validFileExtensions.join(',').replaceAll('.', ''),
          },
        ]) as ValidationResult,
      };
    }

    return {
      payload,
      validationResult: validationResult.concat([
        {
          printPositionId: printPositionId,
          validatorName: validatorName,
          validatorColor: isValidFileExtension ? 'Green' : 'Red',
          message: validFileExtensions.join(',').replaceAll('.', ''),
        },
      ]) as ValidationResult,
    };
  };
